import { CATEGORIES } from "./consts.js";

/**
 * 物件種別を取得する（デフォルト: "all"）
 * 優先順: URLハッシュ → URLクエリ(type) → 地図要素の data-type（条件検索から戻った場合）
 * @returns {string} 物件種別（CATEGORIES の値 または "all"）
 */
export const getPropertyType = () => {
    const hashType = window.location.hash.slice(1);
    if (hashType) return hashType;

    const queryType = new URLSearchParams(window.location.search).get("type");
    if (queryType) return queryType;

    const root = document.querySelector(".js-search-map");
    return root?.dataset.type || "all";
};

/**
 * 条件検索(terms)から引き継いだ検索条件のクエリパラメータを取得する。
 * URLクエリ（地図へGET送信で戻った場合）と data-conditions（初期表示）をマージして返す。
 * type / lat / lng などマーカー取得API側で個別に扱う値は除外する。
 * @returns {URLSearchParams} 検索条件のパラメータ
 */
export const getSearchConditions = () => {
    const excludeKeys = new Set([
        "type",
        "target",
        "latFrom",
        "latTo",
        "lngFrom",
        "lngTo",
    ]);
    const params = new URLSearchParams();

    // URLクエリ（地図へGET送信で戻ってきた場合）を優先。
    // 無い場合のみ data-conditions（サーバーが埋め込んだ初期条件）を使う。
    // ※両方をマージすると同じ条件が二重送信されてしまうため、どちらか一方のみ採用する。
    const search = new URLSearchParams(window.location.search);
    const hasQueryConditions = [...search.keys()].some(
        (key) => !excludeKeys.has(key),
    );

    const root = document.querySelector(".js-search-map");
    const source = hasQueryConditions
        ? search
        : new URLSearchParams(root?.dataset.conditions || "");

    for (const [key, value] of source) {
        if (!excludeKeys.has(key)) params.append(key, value);
    }
    return params;
};

/**
 * 物件種別から取引種別を判定する（事業用のみ rent、他は buy）
 * @returns {"rent"|"buy"} 取引種別
 */
export const getTransactionType = () =>
    getPropertyType() === CATEGORIES.INVEST ? "rent" : "buy";
